import React from "react";
import PropTypes from "prop-types";
import { Screen } from "../Screen";
import { Input } from "./Input";
import DisplayImage from "@learningblocks/exp-constants/lib/Images/ps_voltage_screen.svg";
import { useTranslation } from "react-i18next";

import "./style.scss";

const VOLTAGE_INPUT_ID = "ps_voltage_input";
const CURRENT_INPUT_ID = "ps_current_input";

const TRANSLATION_KEY = {
  VOLTAGE: "Voltage.string",
  CURRENT: "Current.string",
  CurrentPower: "CurrentPower.string",
  VoltageInput: "VoltageInput.string",
  CurrentInput: "CurrentInput.string",
};

export function VoltageDisplay(props) {
  const {
    t,
    //i18n
  } = useTranslation();
  const VOLTAGE_TEXT = t(TRANSLATION_KEY.VOLTAGE);
  const CURRENT_TEXT = t(TRANSLATION_KEY.CURRENT);

  const onClick = (id) => () => {
    const element = document.querySelector("#" + id);
    element.focus();
  };

  return (
    <Screen
      className="ps_settings_voltageDisplay"
      imageSrc={DisplayImage}
      ariaLabel={t(TRANSLATION_KEY.CurrentPower, {
        voltage: props.voltage,
        current: props.current,
      })}
    >
      <div
        className="ps_settings_voltageDisplay_voltage"
        onClick={onClick(VOLTAGE_INPUT_ID)}
        role="button"
        tabIndex="0"
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            onClick(VOLTAGE_INPUT_ID);
          }
        }}
      >
        {VOLTAGE_TEXT}
        <Input
          id={VOLTAGE_INPUT_ID}
          className="ps_settings_voltageDisplay_voltage_input"
          value={props.voltage}
          charWidth={10}
          setValue={props.setVoltage}
          ariaLabel={t(TRANSLATION_KEY.VoltageInput, {
            voltage: props.voltage,
          })}
        />
        V
      </div>
      <div
        className="ps_settings_voltageDisplay_current"
        onClick={onClick(CURRENT_INPUT_ID)}
        role="button"
        tabIndex="0"
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            onClick(CURRENT_INPUT_ID);
          }
        }}
      >
        {CURRENT_TEXT}
        <Input
          id={CURRENT_INPUT_ID}
          className="ps_settings_voltageDisplay_current_input"
          value={props.current}
          charWidth={7}
          setValue={props.setCurrent}
          ariaLabel={t(TRANSLATION_KEY.CurrentInput, {
            current: props.current,
          })}
        />
        A
      </div>
    </Screen>
  );
}

VoltageDisplay.propTypes = {
  /**
   * voltage value to be displayed
   */
  voltage: PropTypes.number,
  /**
   * callback function to change voltage value
   */
  setVoltage: PropTypes.func,
  /**
   * current value to be displayed
   */
  current: PropTypes.number,
  /**
   * callback function to change current value
   */
  setCurrent: PropTypes.func,
};

VoltageDisplay.defaultProps = {
  voltage: 0,
  current: 0,
};
